import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Form, actions, Errors } from "react-redux-form";
import { Grid, Row, Col } from "react-bootstrap";
import ErrorMessages from "../login/error-messages";
import PageTitle from "../common/page-title";
import ArrowButton from "../common/button-arrow";
import RequiredInput from "../common/form/elements/required-input";
import InlineCKEditor from "../common/editor/inline-editor";
import { isLoggedIn } from "../../utils/tokenUtils";
import { validateRegistrationOutlet } from "../../actions/outlet";
import { loadPageContent } from "../../actions/content";
import TextViewer from "../common/editor/text-viewer";

import "./styles.css";

class OutletValidationForm extends React.Component {
  constructor(props) {
    super(props);

    this.pageSlug = "outlet-validation";
    this.state = {};
    if (isLoggedIn()) {
      props.dispatch({ type: "START_REGISTRATION_INTERNAL" });
    } else if (!props.registration.pending) {
      props.dispatch({ type: "START_REGISTRATION_EXTERNAL" });
    }
  }

  componentWillMount() {
    const { registration: { pending, internal }, dispatch } = this.props;

    if (pending && internal) {
      dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
    }
  }

  handleSubmit = (payload) => {
    this.props.dispatch(
      actions.submit(
        "deep.registration.outlet_validation",
        validateRegistrationOutlet(payload, this.props.registration)
      )
    );
  };

  updateErrors = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    const { registration: { pending, internal }, contents } = this.props;

    return (
      <Grid className="registration">
        <Row>
          <Col lg={12}>
            <PageTitle>Register</PageTitle>
          </Col>
        </Row>

        {pending && internal && (
          <Row>
            <Col xs={12}>
              <InlineCKEditor
                identifier={`${this.pageSlug}_content_text`}
                onContentSaved={this.handleContentSaved}
                contents={contents[`${this.pageSlug}_content_text`]}
              />
            </Col>
          </Row>
        )}

        {!(pending && internal) && <TextViewer pageSlug={this.pageSlug}></TextViewer>}

        <Col xs={12} md={6}>
          <Form
            model="deep.registration.outlet_validation"
            onSubmit={this.handleSubmit}
          >
            <Errors
              className="errors"
              model="deep.registration.outlet_validation"
              component={ErrorMessages}
            />

            <RequiredInput
              model=".customer_number"
              controlId="customer_number"
              label="John Player Customer Account Number"
              tooltip="If you don't know your customer account number please contact your John Player representative"
            />

            <RequiredInput
              model=".eircode_or_passcode"
              controlId="eircode_or_passcode"
              label="Eircode or Passcode"
              tooltip="If you don't know your store Eircode or passcode please contact your John Player representative"
            />

            <Row>
              <Col xs={12} sm={6}>
                <ArrowButton color="red" className="pull-right" arrow={false}>
                  Next
                </ArrowButton>
              </Col>
            </Row>
          </Form>
        </Col>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    registration: state.registration,
    contents: state.content.list,
  };
};

export default connect(mapStateToProps)(OutletValidationForm);



// WEBPACK FOOTER //
// ./src/components/outlet-validation/outlet-validation-form.jsx